var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex w-100 h-100 justify-content-center",
      attrs: { id: "UserButtons" },
    },
    [
      _c(
        "ul",
        {
          staticClass:
            "tools-container main-nav-items w-100 no-margin no-sm-border list-unstyled flex",
          class: [
            _vm.ajaxStatusClass,
            _vm.dataStatusClass,
            _vm.userTypeClass,
            _vm.loggedInStatusClass,
          ],
          attrs: { id: "UserButtonsContainer" },
        },
        [
          _vm.dataStatus !== _vm.DATA_STATUS_NONE
            ? [
                _vm.isUserUnregistered
                  ? _c("UserButtonsAnonymousView", {
                      attrs: {
                        links: _vm.links,
                        "use-modal-flow": _vm.useModalFlow,
                        "enable-free-trial": _vm.enableFreeTrial,
                      },
                    })
                  : _c("UserButtonsRegisteredView", {
                      attrs: {
                        "is-user-eligible-for-free-trial":
                          _vm.isUserEligibleForFreeTrial,
                        "is-user-premium": _vm.isUserPremium,
                        "has-user-active-team": _vm.hasUserActiveTeam,
                        "is-user-educational": _vm.isUserEducational,
                        "is-user-registered": _vm.isUserRegistered,
                        "is-user-confirmed": _vm.isUserConfirmed,
                        "user-product": _vm.userProduct,
                        "active-team": _vm.activeTeam,
                        "user-name": _vm.userName,
                        "use-modal-flow": _vm.useModalFlow,
                        "enable-free-trial": _vm.enableFreeTrial,
                        "free-trial-period": _vm.freeTrialPeriod,
                        links: _vm.links,
                        "user-roles": _vm.userRoles,
                      },
                    }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }